__turbopack_context__.v({
  "fadeIn": "Overlay-module-scss-module__rmI8Ea__fadeIn",
  "fadeOut": "Overlay-module-scss-module__rmI8Ea__fadeOut",
  "in": "Overlay-module-scss-module__rmI8Ea__in",
  "out": "Overlay-module-scss-module__rmI8Ea__out",
  "overlay": "Overlay-module-scss-module__rmI8Ea__overlay",
});
